import { OidcUrlHelper } from '@ori/auth';
import ReactDOM from 'react-dom';

import { App } from './App';
import type { AppConfiguration } from './shared/models/AppConfiguration';
import { isNullOrUndefinedOrEmpty } from './shared/utils/isNullOrUndefinedOrEmpty';

export const render = (rootElement: HTMLElement): void => {
  // extract token from URL; only on dev machine, not needed elsewhere
  if (__DEV__) {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);

    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();

      oidcUrlHelper.storeTokenFromParams(searchParams);
    }
  }

  if (!rootElement.dataset.config) {
    throw new TypeError('Missing configuration data attribute!');
  }

  const configuration = JSON.parse(rootElement.dataset.config) as AppConfiguration;
  let requiredConfigurationKeys: Array<Partial<keyof AppConfiguration>> = [
    'currentLanguage',
    'tenant',
    'customerId',
    'identityUrl',
  ];

  if (!__DEV__) {
    requiredConfigurationKeys = [...requiredConfigurationKeys, 'globalApiUrl', 'staticApiUrl'];
  }

  for (const key of requiredConfigurationKeys) {
    if (isNullOrUndefinedOrEmpty(configuration[key])) {
      throw new TypeError(`Missing configuration key ${key} or has no value set!`);
    }
  }

  ReactDOM.render(<App configuration={configuration} />, rootElement);
};
